export default __webpack_public_path__ + "../staticImages/sprite-forecast-unknown-2x.png";